/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { CanvasGridCellBase } from "./CanvasGridCellBase";
import { markType } from "igniteui-react-core";
/**
 * @hidden
 */
var CanvasRowSeparatorCell = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(CanvasRowSeparatorCell, _super);
    function CanvasRowSeparatorCell(a) {
        return _super.call(this, a) || this;
    }
    CanvasRowSeparatorCell.$t = markType(CanvasRowSeparatorCell, 'CanvasRowSeparatorCell', CanvasGridCellBase.$);
    return CanvasRowSeparatorCell;
}(CanvasGridCellBase));
export { CanvasRowSeparatorCell };
//# sourceMappingURL=CanvasRowSeparatorCell.js.map
